import { useParams } from 'react-router'
import { useShallow } from 'zustand/react/shallow'

import type { UserProps } from '@img-arena/consoles-api-dde'
import { ActionDeleteDDEUserItem, ActionsMenu } from '@/components/table/actions'
import { FilterableTable } from '@/components/table/base'
import { STORE_STATUS } from '@/constants/store'
import { ddeApi } from '@/service/ddeApi'
import { useOperatorUsersStoreDDE } from '@/stores/operator/users.dde.store'

import { DDE_TABLE_COLUMNS, DDE_TABLE_FILTERS } from './users.dde.table'

export const DDE_OPERATOR_USERS_TABLE_ID = 'dde-operator-users-table'

export const UsersViewDDE = () => {
  const { operatorId } = useParams()
  const numericOperatorId = operatorId ? Number(operatorId) : undefined

  const { data, isFetching, isLoading } = useOperatorUsersStoreDDE(
    useShallow((state) => ({
      data: state.data,
      isLoading: state.status === STORE_STATUS.loading,
      isFetching: state.status === STORE_STATUS.fetching
    }))
  )

  const { fetchData } = useOperatorUsersStoreDDE(
    useShallow((state) => ({
      fetchData: state.fetchData
    }))
  )

  const handleDeleteUser = async (user: UserProps) => {
    if (!numericOperatorId) return
    await ddeApi.endpoints.users.delete(user.userId)
    await fetchData({ operatorId: numericOperatorId })
  }

  return (
    <FilterableTable
      data={data}
      tableId={DDE_OPERATOR_USERS_TABLE_ID}
      loading={isLoading}
      fetching={isFetching}
      filters={DDE_TABLE_FILTERS}
      columns={DDE_TABLE_COLUMNS}
      clientSideSortAndPagination
      clientSideFilters
      withCheckboxes
      rowActions={
        <ActionsMenu>
          <ActionDeleteDDEUserItem onDelete={handleDeleteUser} />
        </ActionsMenu>
      }
    />
  )
}
